import { AxiosResponse } from "axios";
import { saveAs } from "file-saver";

export const printed = (response: AxiosResponse<any, any>) => {
  return !response.headers["content-type"];
};

export const download = (response: AxiosResponse<any, any>) => {
  const header = response.headers["content-type"];
  const blob = new Blob([response.data], { type: header });
  const fileName = getFileName(response);
  saveAs(blob, fileName);
};

export const outputText = (text: string, fileName: string) => {
  const header = "text/plain;charset=utf-8";
  const blob = new Blob([text], { type: header });
  saveAs(blob, fileName);
};

const getFileName = (response: AxiosResponse<any, any>) => {
  const header = response.headers["content-disposition"];
  if (typeof header === "undefined") {
    throw new TypeError("Content-Dispositionがヘッダーに設定されていません。");
  }
  let fileName = header.substring(header.indexOf("''") + 2, header.length);
  fileName = decodeURI(fileName).replace(/\+/g, " ");
  return fileName;
};
